// extracted by mini-css-extract-plugin
export default {"container":"sF-z","disabled":"tF-z","bgBlack":"uF-z","content":"vF-z","countdown":"wF-z","topCaption":"xF-z","topHeading":"yF-z","heading":"zF-z","copy":"AF-z"};